import CompanyDetailsReports from './CompanyDetailsReports';

export default CompanyDetailsReports;
